"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var CustomPropTypes = _interopRequireWildcard(require("./util/PropTypes"));

var _dataHelpers = require("./util/dataHelpers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var propTypes = {
  value: _propTypes.default.any,
  placeholder: _propTypes.default.string,
  name: _propTypes.default.string,
  searchTerm: _propTypes.default.string,
  autoComplete: _propTypes.default.string,
  textField: CustomPropTypes.accessor,
  allowSearch: _propTypes.default.bool,
  valueComponent: CustomPropTypes.elementType,
  onSearch: _propTypes.default.func,
  onAutofill: _propTypes.default.func.isRequired,
  onAutofillChange: _propTypes.default.func.isRequired
};

var DropdownListInput = _react.default.forwardRef(function (_ref, ref) {
  var name = _ref.name,
      autoComplete = _ref.autoComplete,
      value = _ref.value,
      allowSearch = _ref.allowSearch,
      placeholder = _ref.placeholder,
      textField = _ref.textField,
      searchTerm = _ref.searchTerm,
      onSearch = _ref.onSearch,
      onAutofill = _ref.onAutofill,
      onAutofillChange = _ref.onAutofillChange,
      Component = _ref.valueComponent;

  var _useState = (0, _react.useState)(false),
      autofilling = _useState[0],
      setAutofilling = _useState[1];

  var searchRef = (0, _react.useRef)();

  var handleAutofillDetect = function handleAutofillDetect(_ref2) {
    var animationName = _ref2.animationName;
    var autofilling;
    if (animationName === 'react-widgets-autofill-start') autofilling = true;else if (animationName === 'react-widgets-autofill-cancel') autofilling = false;else return;
    setAutofilling(autofilling);
    onAutofill(autofilling);
  };

  var handleAutofill = function handleAutofill(e) {
    setAutofilling(false);
    onAutofillChange(e);
  };

  var strValue = (0, _dataHelpers.dataValue)(value);
  var inputValue = !value && placeholder ? _react.default.createElement("span", {
    className: "rw-placeholder"
  }, placeholder) : Component ? _react.default.createElement(Component, {
    item: value
  }) : (0, _dataHelpers.dataText)(value, textField);
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      focus: function focus() {
        var _searchRef$current;

        (_searchRef$current = searchRef.current) === null || _searchRef$current === void 0 ? void 0 : _searchRef$current.focus();
      }
    };
  });
  return _react.default.createElement("div", {
    className: "rw-input rw-dropdown-list-input"
  }, autoComplete !== 'off' && _react.default.createElement("input", {
    tabIndex: "-1",
    name: name,
    value: strValue == null ? '' : strValue,
    autoComplete: autoComplete,
    onChange: handleAutofill,
    onAnimationStart: handleAutofillDetect,
    className: (0, _classnames.default)('rw-dropdown-list-search rw-detect-autofill', !autofilling && 'rw-sr')
  }), !autofilling && autoComplete !== 'off' && _react.default.createElement(_react.default.Fragment, null, allowSearch && _react.default.createElement("input", {
    ref: searchRef,
    className: "rw-dropdown-list-search",
    value: searchTerm || '',
    size: (searchTerm || '').length + 2,
    onChange: onSearch
  }), !searchTerm && inputValue));
});

DropdownListInput.displayName = 'DropdownListInput';
DropdownListInput.propTypes = propTypes;
var _default = DropdownListInput;
exports.default = _default;
module.exports = exports["default"];